import styled from "styled-components";

export const ListViewLoading = () => {
  return (
    <ListViewLoadingCss className="listViewLoading">
      <div className="loadingHeader">
        <div className="first">
          <span></span>
          <span></span>
        </div>
        <div className="second"></div>
      </div>
      <div className="loadingMain">
        {[...Array(10)].map((_, ind) => (
          <div key={ind} className="loadingRow">
            <span className="itemOne"></span>
            <span className="itemTwo"></span>
          </div>
        ))}
      </div>

      <div className="footerLoading"></div>
    </ListViewLoadingCss>
  );
};

const ListViewLoadingCss = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  width: 100%;
  padding: 32px;

  > .loadingHeader {
    > .first {
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;

      span {
        width: 330px;
        height: 32px;
        border-radius: 4px;
        background: var(--PEARL, #ecf1f4);
      }
    }
    .second {
      height: 32px;
      border-radius: 4px;
      background: var(--PEARL, #ecf1f4);
    }
  }
  > .loadingMain {
    display: flex;
    flex-direction: column;
    gap: 16px;

    span {
      padding: 0;
    }

    .loadingRow {
      display: flex;
      gap: 16px;

      .itemOne {
        border-radius: 4px;
        background: var(--PEARL, #ecf1f4);
        height: 24px;
        width: 114px;
      }
      .itemTwo {
        border-radius: 4px;
        background: var(--PEARL, #ecf1f4);
        height: 24px;
        flex: 1;
      }
    }
  }

  > .footerLoading {
    height: 32px;
    border-radius: 4px;
    background: var(--PEARL, #ecf1f4);
  }
`;
